import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=26b619d5&"
import script from "./Copy.vue?vue&type=script&lang=js&"
export * from "./Copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports